import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowLeft } from "react-icons/bs";

const HeadSection = () => {
    return (
        <>
            <section className="head__area pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6">
                            <Link to="/" className="z-btn"><i><BsArrowLeft /></i> Back</Link>
                            <div className="section__title">
                                <h2 className="font500">Why Choose Dsider</h2>
                                <span>At Dsider, we offer advanced, industry-leading solutions tailored to meet the unique needs of your business. Here's why we're the right choice:</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HeadSection;